var exports = {
  "w7": "annotation__D8ha3s",
  "RI": "annotationSource__4o2sx5",
  "L0": "annotationMessage__nx7zW9",
  "Yy": "inlineReviewThreadHeading__BatdRr",
};

module.exports = exports;
